import { Typography, styled } from '@mui/material'

export const DefaultTableCellTypography = styled(Typography)(({ theme }) => ({
  variant: 'Body14pxRegular',
  color: theme.palette.neutralLight[900],
}))
